module.exports = __webpack_public_path__ + "static/media/prev-page.9badcfc3.svg";